import React from "react";

const AirAsia = () => {
  return <div>AirAsia</div>;
};

export default AirAsia;
